<template>
  <div>
    <navMenu />

    <hero :heroTitle="$t('registerPage.title')" />

    <registerForm />
    <featured />

    <footerJSK />
  </div>
</template>

<script>
import navMenu from "./../components/navMenu.vue";
import hero from "./../components/hero.vue";
import featured from "./../components/featured.vue";
import registerForm from "./../components/registerForm.vue";
import footerJSK from "./../components/footer.vue";

export default {
  name: "Register",
  components: {
    navMenu,
    hero,
    featured,
    registerForm,
    footerJSK
  },
  mounted () {
    window.scrollTo(0, 0)
  }
};
</script>
